<template>
	<div class="account-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_account_page_v2.sec_10.title.one') }}
					<br />
					{{ $t('new_ui.personal_account_page_v2.sec_10.title.two') }}
				</h2>
				<p>
					{{ $t('new_ui.personal_account_page_v2.sec_10.desc.one') }}<br />
					{{ $t('new_ui.personal_account_page_v2.sec_10.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.personal_account_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_account_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img v-if="!isMobile" :src="img.imgAccountSec10" alt="" />
					<img v-if="isMobile" :src="img.imgAccountSec10M" alt="" />
				</div>
			</div>
		</section>
		<section class="sec-13">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_account_page_v2.sec_13.title.one') }}
					<br /><strong>{{
						$t('new_ui.personal_account_page_v2.sec_13.title.two')
					}}</strong>
					{{ $t('new_ui.personal_account_page_v2.sec_13.title.three') }}
				</h3>
				<ul>
					<li class="list-item-01">
						<h4>
							{{
								$t(
									'new_ui.personal_account_page_v2.sec_13.features.one.title.one',
								)
							}}<br />
							{{
								$t(
									'new_ui.personal_account_page_v2.sec_13.features.one.title.two',
								)
							}}
						</h4>
						<p>
							{{
								$t(
									'new_ui.personal_account_page_v2.sec_13.features.one.description.one',
								)
							}}<br />
							{{
								$t(
									'new_ui.personal_account_page_v2.sec_13.features.one.description.two',
								)
							}}
						</p>
					</li>
					<li class="list-item-02">
						<h4>
							{{
								$t(
									'new_ui.personal_account_page_v2.sec_13.features.two.title.one',
								)
							}}<br />
							{{
								$t(
									'new_ui.personal_account_page_v2.sec_13.features.two.title.two',
								)
							}}
						</h4>
						<p>
							{{
								$t(
									'new_ui.personal_account_page_v2.sec_13.features.two.description.one',
								)
							}}<br />
							{{
								$t(
									'new_ui.personal_account_page_v2.sec_13.features.two.description.two',
								)
							}}
						</p>
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>

<script>
import imgAccountSec10 from '@/assets/images/v2/img-account-sec-10.png';
import imgAccountSec10M from '@/assets/images/v2/img-account-sec-10-m.png';

export default {
	data: () => {
		return {
			mobile: false,
			img: {
				imgAccountSec10,
				imgAccountSec10M,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
